import { render } from "./LabeledTextAreaReports.vue?vue&type=template&id=7b4ed868"
import script from "./LabeledTextAreaReports.vue?vue&type=script&lang=js"
export * from "./LabeledTextAreaReports.vue?vue&type=script&lang=js"

import "./LabeledTextAreaReports.vue?vue&type=style&index=0&id=7b4ed868&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__